import {
    SET_CONFIRM_MESSAGE,
    REMOVE_CONFIRM_MESSAGE,
    SET_IS_CONFIRM,
    SET_CONFIRM_FIELD,
    REMOVE_CONFIRM_FIELD
} from '../../types';

const initialState = {
    message: '',
    isConfirm: null,
    confirmField: ''
};

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_CONFIRM_MESSAGE:
            return {
                ...state,
                message: payload
            };
        case REMOVE_CONFIRM_MESSAGE:
            return {
                ...state,
                message: ''
            };
        case SET_IS_CONFIRM:
            return {
                ...state,
                isConfirm: payload
            };
        case SET_CONFIRM_FIELD:
            return {
                ...state,
                confirmField: payload
            };
        case REMOVE_CONFIRM_FIELD:
            return {
                ...state,
                confirmField: ''
            };
        default:
            return state;
    }
}